/* eslint-disable max-statements */
/**
 * This Optimizely helper should be used exclusively within Redux functions when necessary
 * it uses optimizely-sdk which is designed to work in any javascript code and not limited to React
 * https://docs.developers.optimizely.com/feature-experimentation/docs/javascript-sdk
 */
import config from 'config';
const { pickBy } = require('lodash');

import { createInstance } from '@optimizely/react-sdk/node_modules/@optimizely/optimizely-sdk';
import readCookie from '../../utils/read-cookie';
import OptimizelyManager from './optimizely-manager';
import { extractForcedVariationFromUrl } from './force-optly-variations';

const { cookieName, dataFileTimeout, environment } = config.get(
  'universal.optimizely'
);

const optimizelyManager = new OptimizelyManager(createInstance);
const optimizelyInstance = optimizelyManager.getInstance();

export const getOptimizelyDecision = async (flagName) => {
  const optimizelyUserId = readCookie(cookieName);
  const reduxState = window?.store?.getState();

  const exId = reduxState?.user?.accountProfile?.data?.exId;
  const locale = reduxState?.locale;

  const optimizelyAttributes = pickBy({
    environment,
    'ux_exp_id': optimizelyUserId,
    exId,
    locale,
  });

  await optimizelyInstance.onReady({ timeout: dataFileTimeout });

  const user = optimizelyInstance.createUserContext(
    optimizelyUserId,
    optimizelyAttributes
  );

  const { forcedFlagKey, ForcedVariationKey } = extractForcedVariationFromUrl();

  let decision;

  if (forcedFlagKey && ForcedVariationKey) {
    user.setForcedDecision(
      { flagKey: forcedFlagKey },
      { variationKey: ForcedVariationKey }
    );
    decision = user.decide(forcedFlagKey);
  } else {
    decision = user.decide(flagName);
  }

  const isFeatureFlagEnabled = decision?.enabled || false;
  const variationKey = decision?.variationKey || null;

  return { isFeatureFlagEnabled, variationKey };
};
